import { LineItemsState } from 'types';

import { actions } from './actions';
import { LineItemsAction } from './action_types';

/**
 * Reducer function for managing line items state.
 *
 * @param {LineItemsState} state - The current state.
 * @param {LineItemsAction} action - The action to be handled.
 * @returns {LineItemsState} The new state after applying the action.
 * @throws Will throw an error if the action type is unhandled.
 */
export const lineItemsReducer = (
  state: LineItemsState,
  action: LineItemsAction
): LineItemsState => {
  if (!actions || typeof actions[action.type] !== 'function') {
    throw new Error(`Unhandled action type: ${action.type}`);
  }

  return actions[action.type](state, action);
};
